const enum LANGUAGES {
    RU = 'ru',
    EN = 'en',
};

export default LANGUAGES;